<!-- eslint-disable -->
<template lang="pug">
    .play-box(:class="{'play-box_with-warning': isMobile}")
        .warning(v-if='isMobile')
            svg#rotate(
                version='1.1' xmlns='http://www.w3.org/2000/svg'
                x='0px' y='0px'
                width='40px' height='40px'
                viewbox='0 0 612 612'
                style='enable-background:new 0 0 612 612;' xml:space='preserve'
            )
                no-phone-icon
            div
                | {{ $i18n.t('trainer.trainer_games_gameForDesktopOnly') }}
        template(v-if='!isLoading')
            game-header(
                :time='getTime'
                :slug='type'
                :game-type='parameters && parameters.courseType'
                @soundStateChanged="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            game-preparation-counter(v-if='prepareForGame' :counter="counter")
            .search-game-container__interactive-place(v-if='!prepareForGame')
                .search-game-container__answer-field(v-if='!gameFinished && !isNextExampleButtonShown')
                    .search-game-container__theme
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.searchTopic)}}
                    .search-game-container__amount-of-item
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_haveToFind') + ' ' + parameters.numOfUnknowns}}
                    .search__buttons-container(v-if='!gameFinished && !isNextExampleButtonShown')
                        cs-button.search__button(v-if='gameStarted' :disabled='disableReplyButton' @click='processReply' color="blue")
                            | {{ replyButtonName }}
                .table-container(v-if='!gameFinished && !isNextExampleButtonShown')
                    search-table(
                        :all-items='allItems'
                        @selectItem='selectItem'
                    )
                fireworks(v-if='gameFinished && !isOlympiad && !prepareForGame' :is-mobile='isMobile')
                .search-game-container__result-container(v-if='gameFinished && !isOlympiad || isNextExampleButtonShown')
                    result-image.search-game-container__result-image(status="success")
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="none"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        template(slot="mainButton")
                            cs-button(
                                v-if='isNextExampleButtonShown',
                                @click='getExample',
                                color="blue",
                                v-focus="true"
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        slot
        cs-loader(v-else-if='!isMobile')
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import SearchGameApi from '../../../../api/games/searchGameApi.js'
    import SearchTable from './SearchTable.vue';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import GamePreparationCounter from "../../GamePreparationCounter.vue";

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA () {
        return {
            itemsToFind: [],
            allItems: [],
            isReplyButtonShown: false,
            chainOfAttempts: [[]],
            tableCells: [],
            amountOfExamples: 0,
            isNextExampleButtonShown: false,
            prepareForGame: true,
            hideGameHeader: false,
            isAttemptCorrect: false,
            selectedItems: [],
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        watch: {
            selectedItems: {
                handler (array) {
                    this.isReplyButtonShown = array.length === this.itemsToFind.length;
                },
                deep: true
            },
        },
        data () {
            return DEFAULT_DATA();
        },
        computed: {
            disableReplyButton () {
                return !this.isReplyButtonShown;
            },
            replyButtonName () {
                if (this.selectedItems.length < this.itemsToFind.length) {
                    return this.$i18n.t('trainer.trainer_gamePlayBox_moreForReply');
                }
                if (this.selectedItems.length > this.itemsToFind.length) {
                    return this.$i18n.t('trainer.trainer_gamePlayBox_lessForReply');
                }
                return this.$i18n.t('trainer.trainer_gamePlayBox_reply');
            },
            goodAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.good);
                });
                return count;
            },
            badAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.bad);
                });
                return count;
            },
        },
        methods: {
            fetchData () {
                this.getExercise()
                .then(this.getExample)
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                })
            },
            getExample () {
                if (this.isAttemptCorrect && !this.isOlympiad) {
                    this.chainOfAttempts.push([]);
                    this.sendStat();
                }
                this.isAttemptCorrect = false;
                let paramsForRequest = {
                    selectedTopics: this.parameters.selectedTopics,
                    searchTopic: this.parameters.searchTopic,
                    amountOfSearchingItems: this.parameters.numOfUnknowns,
                    amountOfFalsyItems: Math.pow(this.parameters.tableSize, 2) - this.parameters.numOfUnknowns,
                };
                SearchGameApi.getItemsByRequest(paramsForRequest)
                .then(items => {
                    this.setData(items);
                    if (!this.prepareForGame) {
                        !this.timer && this.setTimer();
                        this.startGame();
                    }
                })
                .then(this.prepareForGame && this.registerSounds())
                .catch(err => this.showErrorMessage(err));
            },
            setData (items) {
                this.itemsToFind = _.cloneDeep(items.filter(item => item.topic === this.parameters.searchTopic));
                this.createArrayForTable(items);
                this.isLoading = false;
                this.gameStarted = true;
                this.isNextExampleButtonShown = false;
            },
            beforeStart () {
                this.prepareForGame = false;
                !this.timer && this.setTimer();
                this.startGame();
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts = this.isAttemptCorrect
                        ? this.chainOfAttempts[this.amountOfExamples - 1].length
                        : this.chainOfAttempts[this.amountOfExamples].length;
                this.gameStat.answers = this.amountOfExamples;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },
            createArrayForTable (items) {
                this.allItems = [];
                let indexFrom = 0;
                let indexTo = this.parameters.tableSize;
                for (let i = 0; i < this.parameters.tableSize; i++) {
                    indexFrom = i ? this.parameters.tableSize + indexFrom : 0;
                    this.allItems.push(items.slice(indexFrom, indexTo));
                    indexTo += this.parameters.tableSize;
                }
            },
            startGame () {
                let items = [];
                this.allItems.forEach(elements => items = items.concat(elements));
                items = _.shuffle(items);
                this.createArrayForTable(items);
                this.$nextTick(() => {
                    this.tableCells = document.querySelectorAll('.search-item');
                    this.tableCells = _.chunk(this.tableCells, this.allItems.length);
                });
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
            },
            selectItem (item, row, column) {
                let element = this.selectedItems.find(element => element.row === row && element.column === column);
                if (!element) {
                    this.selectedItems.push({data: item, row: row, column: column});
                    this.tableCells[row][column].classList.add('search-item_selected');
                } else {
                    this.selectedItems.splice(this.selectedItems.indexOf(element), 1);
                    this.tableCells[row][column].classList.remove('search-item_selected');
                }
            },
            processReply () {
                this.stopAnswerTimer();
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 0
                };
                this.selectedItems.forEach(item => {
                    if (!item.data.correct) {
                        if (this.itemsToFind.find(element => element.id === item.data.id)) {
                            elemOfExampleAttempts.good++;
                            item.data.correct = true;
                        } else {
                            elemOfExampleAttempts.bad++;
                            item.data.correct = false;
                        }
                    }
                });
                this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                if (this.selectedItems.filter(item => item.data.correct).length === this.itemsToFind.length) {
                    this.hideGameHeader = true;
                    this.amountOfExamples++;
                    this.isAttemptCorrect = true;
                    if (this.parameters.exampleComplication
                            && this.parameters.numOfUnknowns < Math.pow(this.parameters.tableSize, 2) - 1
                            && this.chainOfAttempts[this.amountOfExamples - 1].length === 1) {
                        this.parameters.numOfUnknowns++;
                    }
                    if (this.parameters.numOfExamples === this.amountOfExamples) {
                        this.scannerDone();
                        return
                    }
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.resetData();
                    if  (this.isOlympiad) {
                        this.chainOfAttempts.push([]);
                        this.isNextExampleButtonShown = false;
                        this.getExample();
                    }
                    return;
                }
                if (this.isOlympiad) {
                    this.resetData();
                    this.amountOfExamples++;
                    this.chainOfAttempts.push([]);
                    this.isNextExampleButtonShown = false;
                    this.isAttemptCorrect = false;
                    if (this.parameters.numOfExamples === this.amountOfExamples) {
                        this.scannerDone();
                        return
                    }
                    this.getExample();
                } else {
                    this.selectedItems.forEach(item => {
                        let cell = this.tableCells[item.row][item.column];
                        if (item.data.correct) {
                            cell.classList.add('search-item_correct');
                        } else {
                            cell.classList.remove('search-item_selected');
                            cell.classList.add('shake');
                            setTimeout(() => {
                                cell.classList.remove('shake');
                            }, 800);
                        }
                    });
                    this.soundInstance = this.$createjs.Sound.play("clickIncorrect");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    this.selectedItems = this.selectedItems.filter(item => item.data.correct);
                }
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.isAttemptCorrect = false;
                    this.sendStat();
                }
            },
            resetData () {
                this.isNextExampleButtonShown = true;
                this.gameStarted = false;
                this.hideGameHeader = false;
                this.stopTimer();
                this.timer = null;
                this.selectedItems = [];
                this.tableCells = [];
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            scannerDone () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            }
        },
        components: {
            SearchTable,
            GamePreparationCounter
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";

    .play-box_with-warning {
        display: table;
        width: 100%;
        height: 100%;
    }

    .table-container {
        padding: 0 10px 0 10px;
        display: flex;
        justify-content: center;
    }

    .buttons {
        margin-top: 20px;
        text-align: center;
    }

    .search-game-container {
        width: 100%;
        height: 100vh;
        min-height: 100%;
        display: flex;
        justify-content: space-around;
        overflow: hidden;
    }

    .search-game-container__prepare-image {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .search-game-container__prepare-text {
        font-size: 30px;
        white-space: nowrap;
        @media screen and (min-width: 640px) {
            font-size: 60px;
        }
    }

    .search-game-container__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .search-game-container__result-image {
        @include stack-space($space-base);
        max-width: 450px;
        max-height: 450px;
        vertical-align: middle;
    }

    .search-game-container__interactive-place {
        display: flex;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;
        flex: 1 1 auto;
        width: 100%;
        @include media ($xlg) {
            flex-direction: row-reverse;
        }
        .search__buttons-container {
            @include media ($xlg) {
                width: 350px;
            }
        }
    }

    .search-game-container__answer-field {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 30px 18px;
    }

    .search-game-container__theme {
        font-size: 32px;
        font-family: Appetite;
        color: $hsl-color-blue-56;
        text-align: center;
    }

    .search-game-container__amount-of-item {
        font-size: 18px;
    }

    .search__button {
        @media screen and (max-width: 640px) {
            width: 100%;
        }
    }

    .search__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 20px;
    }

    .search__link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .router-link {
        margin: 5px
    }

    .task-for-game {
        text-align: center;
        margin: 5px;
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }
</style>
